import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { DESCRIPTIVE_BADGE_VARIANTS } from 'dpl/common/utils/constants';
import { getShortDateString, getTimeString } from 'dpl/shared/utils/date';
import SmartImage from 'dpl/components/SmartImage';
import DescriptiveBadge from 'dpl/common/components/DescriptiveBadge';

import { ITEM_TYPES, ITEM_TYPE_TO_COLOR } from '../utils/constants';

export default function NewsItem({ item }) {
  const startTime = item.can_rsvp && new Date(item.event_start_at);

  return (
    <div className="BreederNewsNewsItem">
      <div className="flex">
        <div className="mr3">
          <a href={ item.details_url }>
            <SmartImage
              Tag="div"
              lazy
              crop
              width="64px"
              height="64px"
              className="br2 bg-center cover"
              loadingClass="bg-near-white"
              src={ item.cover_photo_url }
              alt={ item.title }
            />
          </a>
        </div>
        <div>
          <p className={ classnames('ttu mb1 f1 fw-medium', ITEM_TYPE_TO_COLOR[item.type]) }>
            { item.type }
          </p>
          <div className="mb2 f2">
            <a
              href={ item.details_url }
              className="underline-hover fw-medium"
            >
              { item.title }
            </a>
            {
              startTime &&
                <p>{ getShortDateString(startTime) }, { getTimeString(startTime) }</p>
            }
          </div>
          {
            item.can_rsvp &&
              <div className="flex fw-medium">
                <a href={ item.event_rsvp_url } className="mr1">
                  <DescriptiveBadge
                    label="RSVP"
                    variant={ DESCRIPTIVE_BADGE_VARIANTS.PRIMARY }
                    size="small"
                  />
                </a>
                <a href={ item.details_url }>
                  <DescriptiveBadge
                    label="Learn More"
                    size="small"
                  />
                </a>
              </div>
          }
        </div>
      </div>
    </div>
  );
}

NewsItem.propTypes = {
  item: PropTypes.shape({
    can_rsvp: PropTypes.bool,
    event_rsvp_url: PropTypes.string,
    event_start_at: PropTypes.string,
    details_url: PropTypes.string,
    cover_photo_url: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.oneOf(Object.values(ITEM_TYPES))
  }).isRequired
};
